import React from "react";
import "./PageStyles.css";

const ContactPage = () => {
  return (
    <div className="page-container">
      <h2>Contact Me</h2>

      <p className="contact-intro">
        I'm open to new opportunities and collaborations. Whether you have a
        project in mind, a question about one of my articles, or just want to
        connect, feel free to reach out. The best ways to get in touch are
        below.
      </p>

      {/* Wrapper for the contact options */}
      <div className="contact-options-wrapper">
        {/* Email Option */}
        <div className="contact-item">
          <div className="contact-icon-wrapper">
            {/* Email SVG Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
          <h3>Via Email</h3>
          <p>For consulting inquiries or general questions.</p>
          {/* IMPORTANT: Change this 'mailto' address 
            to your actual email.
          */}
          <a
            href="mailto:dawid@szafranskicomputing.com"
            className="cta-button primary"
          >
            Send an Email
          </a>
        </div>

        {/* LinkedIn Option */}
        <div className="contact-item">
          <div className="contact-icon-wrapper">
            {/* LinkedIn SVG Icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
            </svg>
          </div>
          <h3>On LinkedIn</h3>
          <p>To connect professionally and see my full profile.</p>
          {/* IMPORTANT: Change this 'href' link 
            to your actual LinkedIn profile URL.
          */}
          <a
            href="https://www.linkedin.com/in/YOUR_LINKEDIN_ID"
            target="_blank"
            rel="noopener noreferrer"
            className="cta-button secondary"
          >
            View Profile
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
